import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
var DialogComponent = /** @class */ (function () {
    function DialogComponent() {
    }
    DialogComponent.prototype.ngOnInit = function () {
    };
    DialogComponent.prototype.Forwardconfirmation = function (msg) {
        return Swal.fire({
            title: 'Are you sure to' + ' ' + msg + '?',
            text: 'After that you can not take any action on that complaint',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Change it!',
            cancelButtonText: 'No, keep it'
        }).then(function (result) {
            if (result.value) {
                return true;
                // For more information about handling dismissals please visit
                // http://sweetalert2.github.io/#handling-dismissals
            }
            else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire('Cancelled', 'Your ' + msg + ' data is not modified :)', 'error');
                return false;
            }
        });
    };
    DialogComponent.prototype.confirmation = function (msg) {
        return Swal.fire({
            title: 'Are you sure?',
            text: 'You change in to ' + msg,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Change it!',
            cancelButtonText: 'No, keep it'
        }).then(function (result) {
            if (result.value) {
                return true;
                // For more information about handling dismissals please visit
                // http://sweetalert2.github.io/#handling-dismissals
            }
            else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire('Cancelled', 'Your ' + msg + ' data is not modified :)', 'error');
                return false;
            }
        });
    };
    DialogComponent.prototype.statusChangeConfirmation = function (msg) {
        return Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to change' + msg + '?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Change it!',
            cancelButtonText: 'No, keep it'
        }).then(function (result) {
            if (result.value) {
                return true;
            }
            else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire('Cancelled', 'Your ' + msg + ' is not modified :)', 'error');
                return false;
            }
        });
    };
    DialogComponent.prototype.EditItemPopup = function (msg) {
        return Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to edit item on this complaint!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then(function (result) {
            if (result.value) {
                return true;
                // For more information about handling dismissals please visit
                // http://sweetalert2.github.io/#handling-dismissals
            }
            else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire('Cancelled', 'Your ' + msg + ' data is not modified :)', 'error');
                return false;
            }
        });
    };
    DialogComponent.prototype.delete = function (msg) {
        return Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this ' + msg,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it'
        }).then(function (result) {
            if (result.value) {
                return true;
                // For more information about handling dismissals please visit
                // http://sweetalert2.github.io/#handling-dismissals
            }
            else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire('Cancelled', 'Your ' + msg + ' is safe &#x263A;', 'error');
                return false;
            }
        });
    };
    DialogComponent.prototype.success = function (title, msg) {
        Swal.fire(title + '!', msg + '.', 'success');
    };
    DialogComponent.prototype.error = function (msg) {
        Swal.fire({
            type: 'error',
            title: 'Oops...',
            text: msg,
        });
    };
    DialogComponent = tslib_1.__decorate([
        Injectable({ providedIn: 'root' }),
        tslib_1.__metadata("design:paramtypes", [])
    ], DialogComponent);
    return DialogComponent;
}());
export { DialogComponent };
//# sourceMappingURL=DialogComponent.js.map